export enum Lang {
  Hebrew = "he",
}
